module.exports = __webpack_public_path__ + "static/media/sim-waving.e92f4580.gif";